import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from 'firebase/auth'

interface AuthState {
  isDeterminate: boolean
  isAdmin: boolean
  user: User | null
}

const initialState: AuthState = {
  isDeterminate: false,
  isAdmin: false,
  user: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState: (state, action: PayloadAction<AuthState>) => {
      const { isDeterminate, user, isAdmin } = action.payload
      state.isDeterminate = isDeterminate
      state.user = user
      state.isAdmin = isAdmin
    },
    setAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload
    },
    signOut: (state) => {
      state.isDeterminate = false
      state.user = null
      state.isAdmin = false
    },
  },
})

export default authSlice
